import { Ecommerce, ecommerce } from '@uds/tagmg';
import { promoNameToPromoId } from 'domain/logic/promotion';

const sendPromotion = ({ promotion, ec }: { promotion?: string; ec?: Ecommerce }) => {
  // for test purposes, we allow an overwrite
  const ecomm = ec || ecommerce;
  if (!promotion) {
    return;
  }

  const promoId = promoNameToPromoId(promotion);
  ecomm([
    [
      'addPromo',
      {
        id: promoId,
        name: promotion,
      },
    ],
    ['setAction', 'promo_click'],
  ]);
};

export default sendPromotion;
